import { render, staticRenderFns } from "./ElementSwitch.vue?vue&type=template&id=32849bc0&scoped=true"
import script from "./ElementSwitch.vue?vue&type=script&lang=js"
export * from "./ElementSwitch.vue?vue&type=script&lang=js"
import style0 from "./ElementSwitch.vue?vue&type=style&index=0&id=32849bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32849bc0",
  null
  
)

export default component.exports